import { SxProps, Theme } from '@mui/material/styles';

export const DROPDOWN_CONFIG = {
       width: '400px',
       maxWidth: '400px',
       minHeight: '40px',
       padding: {
              select: '12px 16px',
              menuItem: '8px 16px',
       }
} as const;

export const dropdownStyles: { [key: string]: SxProps<Theme> } = {
       root: {
              width: DROPDOWN_CONFIG.width
       },
       select: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              padding: DROPDOWN_CONFIG.padding.select,
       },
       menuItem: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: DROPDOWN_CONFIG.maxWidth,
              padding: DROPDOWN_CONFIG.padding.menuItem,
              minHeight: DROPDOWN_CONFIG.minHeight,
              '&:hover': {
                     backgroundColor: 'action.hover',
              }
       }
} as const;

export const getDropdownSxProps = () => ({
       '& .MuiSelect-select': dropdownStyles.select,
       '& .MuiMenuItem-root': dropdownStyles.menuItem,
});

export default dropdownStyles; 